/*
 * @Description:
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */
import { BaseService } from './base-service';

class SetService extends BaseService {
  /********************************
   * 角色权限
   ********************************/
  /**
   *  角色权限-角色-所有菜单列表
   *
   * @author zl
   * @returns
   * @memberof SetService
   */
  getMenuList() {
    return this.request({
      method: 'GET',
      url: `/resource/listPage`
    });
  }
  /**
   *  角色权限-角色-角色所有权限
   *
   * @author zl
   * @returns
   * @memberof SetService
   */
  getMenuListByRoleId(params) {
    return this.request({
      method: 'GET',
      url: `/resource/getResourceByRoleId`,
      params
    });
  }
  /**
   *  角色权限-角色-角色所有权限
   *
   * @author zl
   * @returns
   * @memberof SetService
   */
  saveRule(data) {
    return this.request({
      method: 'POST',
      url: `/resource/save`,
      data
    });
  }
  /**
   *  界面管理-菜单界面管理-获取所有菜单
   *
   * @author zl
   * @returns
   * @memberof SetService
   */
  getMenuOptional(params) {
    return this.request({
      method: 'GET',
      url: `/menu/optional`,
      params
    });
  }
  /**
   *  界面管理-菜单界面管理-获取已选择菜单项
   *
   * @author zl
   * @returns
   * @memberof SetService
   */
  getSelectedMenuOptional(params) {
    return this.request({
      method: 'GET',
      url: `/menu/manager/menus`,
      params
    });
  }
  /**
   *  界面管理-菜单界面管理-新增/编辑菜单项
   *
   * @author zl
   * @returns
   * @memberof SetService
   */
  menuManagerUpdate(data) {
    return this.request({
      method: 'POST',
      url: `/menu/manager/update`,
      data
    });
  }

  /**
   *  角色权限-角色-角色权限列表
   *
   * @author CaoJianBo
   * @returns
   * @memberof SetService
   */
  roleList(params) {
    return this.request({
      method: 'get',
      url: `/role/list`,
      params
    });
  }
  /**
   *  角色权限-角色-角色新增
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @param  {String} data.roleName
   * @returns
   * @memberof SetService
   */
  roleAdd(data) {
    return this.request({
      method: 'post',
      url: `/role/add`,
      data
    });
  }
  /**
   *  角色权限-角色-角色编辑
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @param  {integer} data.roleId
   * @param  {String} data.roleName
   * @returns
   * @memberof SetService
   */
  roleUpdate(data) {
    return this.request({
      method: 'post',
      url: `/role/update`,
      data
    });
  }
  /**
   *  角色权限-角色-角色删除
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @param  {integer} data.roleId
   * @returns
   * @memberof SetService
   */
  roleDelete(params) {
    return this.request({
      method: 'get',
      url: `/role/delete`,
      params
    });
  }
  /**
   *  角色权限-角色员工-角色员工列表
   *
   * @author CaoJianBo
   * @param  {Object} params
   * @param  {integer} params.roleId
   * @returns
   * @memberof SetService
   */
  roleUserList(params) {
    return this.request({
      method: 'get',
      url: `/role/user/list`,
      params
    });
  }
  /**
   *  角色权限-角色员工-移除角色员工列表
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @param  {integer} data.roleId
   * @param  {String} data.userId
   * @returns
   * @memberof SetService
   */
  roleUserDelete(params) {
    return this.request({
      method: 'get',
      url: `/role/user/delete`,
      params
    });
  }
  /**
   *  角色权限--角色员工--添加人员
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @param  {Array} data.userIDs
   * @returns
   * @memberof SetService
   */
  roleAddBatch(data) {
    return this.request({
      method: 'post',
      url: `/role/user/addBatch`,
      data
    });
  }
  /**
   *  角色权限--角色员工--转移创建者
   *
   * @author CaoJianBo
   * @param  {Object} params
   * @param  {Array} params.userId
   * @returns
   * @memberof SetService
   */
  transferCreator(params) {
    return this.request({
      method: 'get',
      url: `/user/transferCreator`,
      params
    });
  }
  /**
   *  角色权限-数据权限-获取数据权限
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @param  {integer} data.roleId
   * @returns
   * @memberof SetService
   */
  getRolePermission(params) {
    return this.request({
      method: 'get',
      url: `/role/permission/get`,
      params
    });
  }
  /**
   *  角色权限-数据权限-保存数据权限
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @param  {integer} data.roleId
   * @returns
   * @memberof SetService
   */
  rolePermissionSave(data) {
    return this.request({
      method: 'post',
      url: `/role/permission/save`,
      data
    });
  }

  /**
   *  角色权限-操作权限-获取菜单权限
   *
   * @author CaoJianBo
   * @param  {Object} params
   * @param  {integer} params.roleId
   * @returns
   * @memberof SetService
   */
  getResourceList(params) {
    return this.request({
      method: 'get',
      url: `/role/resource/list`,
      params
    });
  }
  /**
   *  角色权限-操作权限-保存菜单权限
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @param  {integer} data.roleId
   * @param  {integer} data.resourceIds
   * @returns
   * @memberof SetService
   */
  saveResourceAllot(data) {
    return this.request({
      method: 'post',
      url: `/role/resource/allot`,
      data
    });
  }
  /********************************
   * 线索设置
   ********************************/
  /**
   *  线索设置--获取所有字段
   *
   * @author CaoJianBo
   * @param  {Object} params
   * @returns
   * @memberof setService
   */
  getField(params) {
    return this.request({
      method: 'get',
      url: `/clue_setting/field/enabled`,
      params
    });
  }
  /**
   *  线索设置--编辑--字段修改
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  updateSettingField(data) {
    return this.request({
      method: 'post',
      url: `/clue_setting/field/update`,
      data
    });
  }
  /**
   *  线索设置--新增字段
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  addSettingField(data) {
    return this.request({
      method: 'post',
      url: `/clue_setting/field/add`,
      data
    });
  }

  /********************************
   * 角色权限--数据权限--自定义规则
   ********************************/
  /**
   *  角色权限-数据权限-自定义规则--列表
   *
   * @author ylq
   * @param  {Object} data
   * @returns
   * @memberof SetService
   */
  getDataPermissionRuleList(data) {
    return this.request({
      method: 'get',
      url: `/additional/rule/list`,
      params: data
    });
  }

  /**
   *  角色权限-数据权限-自定义规则--获取单条
   *
   * @author ylq
   * @param  {Object} data
   * @returns
   * @memberof SetService
   */
  getDataPermissionRule(data) {
    return this.request({
      method: 'get',
      url: `/additional/rule/detail`,
      params: data
    });
  }

  /**
   *  角色权限-数据权限-自定义规则--启用/暂停
   *
   * @author ylq
   * @param  {Object} data
   * @returns
   * @memberof SetService
   */
  changePermissionRuleStatus(data) {
    return this.request({
      method: 'post',
      url: `/additional/rule/change/isEnabled`,
      data
    });
  }
  /********************************
   * 外呼人员
   ********************************/
  /**
   *  外呼人员--外呼人员筛选列表
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @param  {integer} data.userName
   * @returns
   * @memberof setService
   */
  getOutBoundList(data) {
    return this.request({
      method: 'post',
      url: `/sysOutBound/list`,
      data
    });
  }
  /**
   *  外呼人员--新增人员
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @param  {integer} data.userId
   * @returns
   * @memberof setService
   */
  sysOutBoundAdd(data) {
    return this.request({
      method: 'post',
      url: `/sysOutBound/add`,
      data
    });
  }
  /**
   *  外呼人员--编辑人员
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @param  {integer} data.userId
   * @returns
   * @memberof setService
   */
  sysOutBoundUpdate(data) {
    return this.request({
      method: 'post',
      url: `/sysOutBound/update`,
      data
    });
  }
  /********************************
   * 规则管理
   ********************************/
  /**
   *  规则管理--对象规则映射-列表
   *
   * @author ylq
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  getRuleList(data) {
    return this.request({
      method: 'post',
      url: `/objectMappingRule/list`,
      data
    });
  }
  /**
   *  规则管理--对象规则映射-获取规则详情
   *
   * @author ylq
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  getRuleDetail(data) {
    return this.request({
      method: 'post',
      url: `/objectMappingRule/info`,
      data
    });
  }
  /**
   *  规则管理--对象规则映射-获取对象列表
   *
   * @author ylq
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  getRuleObjList(data) {
    return this.request({
      method: 'get',
      url: `/objectMappingRule/objects?apiIndex=${Math.random() * 100}`,
      params: data
    });
  }
  /**
   *  规则管理--对象规则映射-获取对象的字段
   *
   * @author ylq
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  getObjFields(data) {
    return this.request({
      method: 'get',
      url: `/objectMappingRule/settings`,
      params: data
    });
  }
  /**
   *  规则管理--对象规则映射-更新规则
   *
   * @author ylq
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  updateRule(data) {
    return this.request({
      method: 'post',
      url: `/objectMappingRule/addOpUpdate`,
      data
    });
  }
  /********************************
   * 视图管理
   ********************************/
  /*
   *
   * @author ldd
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  //获取视图列表
  getViewList(data) {
    return this.request({
      method: 'post',
      url: `/view/list/v2`,
      data
    });
  }

  /**
   * @brief 视图初始化
   * @param data
   * @return {AxiosPromise}
   */
  layoutInitV2(data) {
    return this.request({
      method: 'POST',
      url: '/layout/init/v2',
      data
    });
  }
  /**
   * @brief 视图下获取表单设计字段【包含系统字段】
   * @param data
   * @return {AxiosPromise}
   */
  getFormDesignFields(params) {
    return this.request({
      method: 'GET',
      url: '/layout/allField',
      params
    });
  }
  /**
   * @brief 新建视图
   * @param data
   * @return {AxiosPromise}
   */
  addLayoutV2(data) {
    return this.request({
      method: 'POST',
      url: '/view/add/v2',
      data
    });
  }
  /**
   * @brief 直接新建视图，没有form版本
   * @param data
   * @return {AxiosPromise}
   */
  addLayoutDirect(data) {
    return this.request({
      method: 'POST',
      url: '/view/frontAdd',
      data
    });
  }
  /**
   * @brief 快捷编辑视图名称
   * @param data
   * @return {AxiosPromise}
   */
  updateLayoutName(data) {
    return this.request({
      method: 'POST',
      url: '/view/frontUpdateName',
      data
    });
  }
  /**
   * @brief 视图详情
   * @param params
   * @return {AxiosPromise}
   */
  detailLayoutV2(params) {
    return this.request({
      method: 'GET',
      url: '/view/detail/v2',
      params
    });
  }
  /**
   * @brief 编辑视图
   * @param data
   * @return {AxiosPromise}
   */
  updateLayoutV2(data) {
    return this.request({
      method: 'POST',
      url: '/view/update/v2',
      data
    });
  }
  /**
   * @brief 删除视图
   * @param data
   * @return {AxiosPromise}
   */
  deleteLayoutV2(params) {
    return this.request({
      method: 'GET',
      url: '/view/delete/v2',
      params
    });
  }
  //视图状态修改
  changeStatus(data) {
    return this.request({
      method: 'post',
      url: `/view/enable`,
      data
    });
  }
  //新增接口
  addView(data) {
    return this.request({
      method: 'post',
      url: `/view/add`,
      data
    });
  }
  //复制接口 复制非外链布局时，同步复制布局字段配置
  copyView(data) {
    return this.request({
      method: 'POST',
      url: `/view/copyfullview`,
      data
    });
  }
  //编辑接口
  updateView(data) {
    return this.request({
      method: 'post',
      url: `/view/update`,
      data
    });
  }
  // 视图排序接口
  sortViewV2(data) {
    const params = {
      method: 'post',
      url: `/view/sort/v2`,
      params: { apiIndex: data.apiIndex },
      data: data
    };
    return this.request(params);
  }

  //获取字段类型条件
  getDynamic(params) {
    return this.request({
      method: 'get',
      url: `/dynamic/conditions`,
      params
    });
  }
  //表格排序
  sortListApi(data) {
    return this.request({
      method: 'post',
      url: `/view/sort`,
      data
    });
  }
  //查询entity所有字段
  getEntitySettings(data) {
    return this.request({
      method: 'post',
      url: `/entity/settings`,
      params: { apiIndex: data.apiIndex },
      data
    });
  }
  //查询视图回显
  dynamicSettings(params) {
    return this.request({
      method: 'get',
      url: `/view/detail`,
      params
    });
  }
  /********************************
   * 对象管理---系统对象--布局相关
   ********************************/
  /**
   *
  /**
   * @description: 新增布局---10：列表页布局 20：详情页布局 30：新建页布局 40：编辑页布局
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  layoutAdd(data) {
    return this.request({
      method: 'post',
      url: `/layout/add`,
      data
    });
  }

  /**
   * @description:查询其他布局标签页
   * @return {*}
   * @author: 袁翔
   */
  layoutTab(params) {
    return this.request({
      method: 'get',
      url: `/layout/tab`,
      params
    });
  }

  /**
   * @description:复制页签到其他布局/页签
   * @return {*}
   * @author: 袁翔
   */
  layoutCopy(data) {
    return this.request({
      method: 'post',
      url: `/layout/tab/copy`,
      data: data
    });
  }

  /**
   * @description:布局列表
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  layoutList(params) {
    return this.request({
      method: 'post',
      url: `/layout/list?apiIndex=${params.apiIndex}`,
      // params: { apiIndex: params?.apiIndex || 0 },
      data: params
    });
  }
  /**
   * @description:布局详情
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  layoutDetail(params) {
    return this.request({
      method: 'get',
      url: `/layout/detail`,
      params
    });
  }

  /**
   * @description:编辑布局
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  layoutUpdate(data) {
    return this.request({
      method: 'post',
      url: `/layout/update`,
      data
    });
  }
  /**
   * @description: 分配布局--获取分配布局列表
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  viewLayoutList(data) {
    return this.request({
      method: 'post',
      url: `/viewLayout/list`,
      data
    });
  }
  //编辑布局
  viewLayoutAdd(data) {
    return this.request({
      method: 'post',
      url: `/viewLayout/add`,
      data
    });
  }
  /**
   * @description: 删除布局
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */

  delLayout(params) {
    return this.request({
      method: 'get',
      url: `/layout/delete`,
      params
    });
  }
  /**
   *  布局模块--初始化布局
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  layoutInit(data) {
    return this.request({
      method: 'post',
      url: `/layout/init`,
      data
    });
  }
  /**
   * @description: 表单发布--查询
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */

  getFormDesignDetail(params) {
    return this.request({
      method: 'get',
      url: `/formDesign/formDesignDetail`,
      params
    });
  }

  getFormDesignDetailV2(params) {
    return this.request({
      method: 'get',
      url: `/formDesign/formDetail`,
      params
    });
  }
  /**
   * @description: 表单发布保存
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */

  formDesign(data) {
    return this.request({
      method: 'post',
      url: `/formDesign/formDesign/v2`,
      data
    });
  }
  /***********************************
   *  @description: 布局模块--自定义对象
   ***********************************/
  /**
   * @description: 更新自定义对象状态
   * @param data
   * @return {*}
   */
  updateCustomStatus(data) {
    return this.request({
      method: 'POST',
      url: `/custom/updateStatus`,
      data
    });
  }

  /**
   * @description: 新增自定义对象
   * @param data
   * @return {*}
   */
  addCustomObject(data) {
    return this.request({
      method: 'POST',
      url: `/custom/add`,
      data
    });
  }

  /**
   * @description: 删除自定义对象
   * @param params
   * @return {*}
   */
  deleteCustomObject(params) {
    return this.request({
      method: 'GET',
      url: `/custom/delete`,
      params
    });
  }
  /**
   * @description: 检查自定义对象是否可以删除
   * @param params
   * @return {*}
   */
  deleteCheck(params) {
    return this.request({
      method: 'GET',
      url: `/custom/deleteCheck`,
      params
    });
  }

  /********************************
   * 查重设置
   ********************************/
  /**
   * @description: 查重设置
   * @return {*}
   * @author: ldd
   */
  //获取查重列表
  getRepeatList(params) {
    return this.request({
      method: 'get',
      url: `/sys-entity-repeat/get`,
      params
    });
  }
  //关闭查重
  closeRepeat(params) {
    return this.request({
      method: 'get',
      url: `/sys-entity-repeat/reset`,
      params
    });
  }
  //更新
  updateRepeat(data) {
    return this.request({
      method: 'post',
      url: `/sys-entity-repeat/update`,
      data
    });
  }

  /********************************
   * 规则管理---映射相关api
   ********************************/
  /**
   * @description: 映射规则停用/启用
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */

  updateRuleStatus(data) {
    return this.request({
      method: 'post',
      url: `/objectMappingRule/enableDisable`,
      data
    });
  }

  /**
   * @description: 规则管理-接口映射规则
   * @param {*} data
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  updateMappingRule(data) {
    return this.request({
      method: 'post',
      url: `/objectMappingRule/interfaceAddOrUpdate`,
      data
    });
  }
  /**
   * @description: 规则管理-接口映射规则-获取对象字段
   * @param {*} data
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  updateMappingRuleList(params) {
    return this.request({
      method: 'get',
      url: `/objectMappingRule/settingsList`,
      params
    });
  }
  /**
   * @description: 规则管理-接口映射规则-删除对象规则
   * @param {*} data
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  delRuleList(params) {
    return this.request({
      method: 'get',
      url: `/objectMappingRule/delete`,
      params
    });
  }
  /**
   * @description: 规则管理-接口映射规则-对象规则重复校验
   * @param {*} data
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  checkRepeatRule(data) {
    return this.request({
      method: 'post',
      url: `/objectMappingRule/checkRepeat`,
      data
    });
  }
  /********************************
   * 对象管理---系统对象
   ********************************/

  /**
   *  系统对象--修改字段名称
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  field_name(data) {
    return this.request({
      method: 'post',
      url: `/clue_setting/field/update/field_name`,
      data
    });
  }
  /**
   *  系统对象--获取当前租户的系统对象列表
   *
   * @author CaoJianBo
   * @param  {Object} params
   * @returns
   * @memberof setService
   */
  getSysObjList(params) {
    return this.request({
      method: 'get',
      url: `/sys-entity/list`,
      params
    });
  }
  /**
   * @description:系统对象--获取所有字段信息（不包含fieldExt信息）
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  sysEntitySetting(params) {
    return this.request({
      method: 'get',
      url: `/entity/setting/list`,
      params
    });
  }
  /**
   * @description:查询对象下所有启用字段exts
   * @return {*}
   * @author: 袁翔 yuanxiang@qfei.cn
   */
  sysEntitySettingExts(params) {
    return this.request({
      method: 'get',
      url: `/entity/setting/field/exts`,
      params
    });
  }
  /**
   * @description:系统对象--获取字段--字段设置ext信息或者其他信息
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  sysEntityfieldExt(params) {
    return this.request({
      method: 'get',
      url: `/entity/setting/field/ext`,
      params
    });
  }
  /**
   * @description:系统对象--查询计算字段公式中字段是否启用
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  computerFieldCheck(params) {
    return this.request({
      method: 'get',
      url: `/formDesign/computerFieldCheck`,
      params
    });
  }
  /**
   * @description: 判断字段是否可以禁用
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  getStatus(params) {
    return this.request({
      method: 'get',
      url: `/compute/containKey`,
      params
    });
  }
  /**
   *  系统对象--根据id查询系统对象详情
   *
   * @author CaoJianBo
   * @param  {Object} params
   * @returns
   * @memberof setService
   */
  updateStatus(params) {
    return this.request({
      method: 'get',
      url: `/clue_setting/field/updateStatus`,
      params
    });
  }
  /**
   *  系统对象--根据id查询系统对象详情
   *
   * @author CaoJianBo
   * @param  {Object} params
   * @returns
   * @memberof setService
   */
  getSysFieldList(params) {
    return this.request({
      method: 'get',
      url: `/clue_setting/sys_field/list/${params}`
    });
  }
  /**
   *  系统对象--字段布局列表接口
   *
   * @author JNN
   * @param  {Object} params
   * @returns
   * @memberof setService
   */
  layoutListInit(params) {
    return this.request({
      method: 'get',
      url: `/entity/setting/config/layout/init`,
      params
    });
  }
  /**
   *  对象管理--字段设置--查询关联对象信息
   * @author 曲世杰
   * @returns
   * @memberof setService
   */
  getClueEntityList(params) {
    return this.request({
      method: 'GET',
      url: `/clue_setting/entity/list`,
      params
    });
  }
  /**
   *  对象管理--字段设置--查询汇总字段列表
   * @author 曲世杰
   * @returns
   * @memberof setService
   */
  getClueSum(params) {
    return this.request({
      method: 'GET',
      url: `/clue_setting/field/sum`,
      params
    });
  }
  /**
   *  对象管理--字段设置--查询汇总字段详情
   * @author 曲世杰
   * @returns
   * @memberof setService
   */
  getClueSumDetail(params) {
    return this.request({
      method: 'GET',
      url: `/clue_setting/sum`,
      params
    });
  }

  /**
   *  系统对象--枚举反射获取值列表
   *
   * @author CaoJianBo
   * @param  {Object} params
   * @returns
   * @memberof setService
   */
  getSysObjEnumList(params) {
    return this.request({
      method: 'get',
      url: `/sys-entity/detail?apiIndex=${Math.random() * 100}`,
      params: params
    });
  }
  /**
   *  系统对象--布局列表
   *
   * @author HuCaiLi
   * @param  {Object} params
   * @returns
   * @memberof setService
   */
  getLayoutList(data) {
    return this.request({
      method: 'post',
      url: `/layout/list`,
      data
    });
  }

  /**
   *  系统对象--基本信息修改
   *
   * @author qushijie
   * @param  {Object} data
   * @returns
   * @memberof setService
   */

  updateSysObj(data) {
    return this.request({
      method: 'post',
      url: `/sys-entity/update`,
      data
    });
  }

  /**
   * 系统对象--按钮设置列表
   * @author qushijie
   * @param  {Object} data
   * @returns
   * @memberof setService
   */

  getBtnSetList(params) {
    return this.request({
      method: 'get',
      url: `/button/setting/list`,
      params
    });
  }

  /**
   *  系统对象--按钮设置编辑
   * @param  {Object} data
   * @returns
   * @memberof setService
   */

  updateBtnSet(data) {
    return this.request({
      method: 'post',
      url: `/button/setting/update`,
      data
    });
  }

  /**
   *  系统对象--布局按钮查询
   *
   * @author 曲世杰
   * @param  {Object} data
   * @returns
   * @memberof setService
   */

  getBtnSetListByLayout(params) {
    return this.request({
      method: 'get',
      url: `/layout/buttons`,
      params
    });
  }

  /**
   *  外部对象--获取外部对象列表
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  getOutObjectList(data) {
    return this.request({
      method: 'post',
      url: `/out/object/list`,
      data
    });
  }
  /**
   *  外部对象--获取审批组织列表
   *
   * @author CaoJianBo
   * @param  {Object} params
   * @returns
   * @memberof setService
   */
  getApprovalOrgList(params) {
    return this.request({
      method: 'get',
      url: `/auth/getAppListV2`,
      params
    });
  }
  /**
   *  E签宝--查询接口
   *
   * @author CaoJianBo
   * @param  {Object} params
   * @returns
   * @memberof setService
   */
  getEsignOpen(params) {
    return this.request({
      method: 'get',
      url: `/esignOpen/get`,
      params
    });
  }
  /**
   *  E签宝--开通账号
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  openEsign(data) {
    return this.request({
      method: 'post',
      url: `/esignOpen/add`,
      data
    });
  }
  /**
   *  E签宝--删除合同模板
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  deleteContractTemplate(data) {
    return this.request({
      method: 'post',
      url: `/out/object/delete`,
      data
    });
  }
  /**
   *  E签宝--印章查询接口
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  getSealsList(data) {
    return this.request({
      method: 'post',
      url: `/eSign/template/seals`,
      data
    });
  }
  /**
   *  E签宝--印章授权
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  controlStamping(data) {
    return this.request({
      method: 'post',
      url: `/eSign/template/sealauth`,
      data
    });
  }
  /**
   *  E签宝--新增映射查重
   *
   * @author CaoJianBo
   * @param  {Object} params
   * @returns
   * @memberof setService
   */
  checkMappingName(params) {
    return this.request({
      method: 'get',
      url: `/objectMappingRule/verify`,
      params
    });
  }
  /**
   *  E签宝--刷新字段
   *
   * @author CaoJianBo
   * @param  {Object} params
   * @returns
   * @memberof setService
   */
  refreshField(params) {
    return this.request({
      method: 'get',
      url: `/out/field/auto/update`,
      params
    });
  }
  /**
   *  E签宝--获取签约设置列表
   *
   * @author LiDongDong
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  getSigningList(data) {
    return this.request({
      method: 'post',
      url: `/esign/setting/list`,
      data
    });
  }
  /**
   *  E签宝--删除签约列表项
   *
   * @author LiDongDong
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  deleteSigning(data) {
    return this.request({
      method: 'post',
      url: `/esign/setting/delete`,
      data
    });
  }
  /**
   *  E签宝--签约状态修改
   *
   * @author LiDongDong
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  updateSigning(data) {
    return this.request({
      method: 'post',
      url: `/esign/setting/update`,
      data
    });
  }
  /**
   *  E签宝--签约新增
   *
   * @author LiDongDong
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  addSigningSave(data) {
    return this.request({
      method: 'post',
      url: `/esign/setting/save`,
      data
    });
  }
  /**
   *  E签宝--签约详情
   *
   * @author LiDongDong
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  getSignDetail(params) {
    return this.request({
      method: 'get',
      url: `/esign/setting/get`,
      params
    });
  }
  /**
   *  E签宝--印章查询接口用于设置
   *
   * @author LiDongDong
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  getSealsAll(data) {
    return this.request({
      method: 'post',
      url: `/eSign/template/sealAll`,
      data
    });
  }
  /**
   *  E签宝--签约名称去重接口
   *
   * @author LiDongDong
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  getSignNameRepeat(params) {
    return this.request({
      method: 'get',
      url: `/esign/setting/verify`,
      params
    });
  }
  /**
   *  E签宝--获取映射规则
   *
   * @author LiDongDong
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  getObjectByRuleId(params) {
    return this.request({
      method: 'get',
      url: `/esign/setting/getObjectByRuleId`,
      params
    });
  }
  /**
   *  E签宝--组件详情信息
   *
   * @author LiDongDong
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  getSignDetailInfo(data) {
    return this.request({
      method: 'post',
      url: `/eSign/template/detail`,
      data
    });
  }

  /**
   *  外部对象--新增外部对象
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  addOutObject(data) {
    return this.request({
      method: 'post',
      url: `/out/object/add`,
      data
    });
  }
  /**
   *  外部对象--编辑外部对象
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  updateOutObject(data) {
    return this.request({
      method: 'post',
      url: `/out/object/update`,
      data
    });
  }
  /**
   *  外部对象--获取外部对象类型枚举值
   *
   * @author CaoJianBo
   * @param  {Object} params
   * @returns
   * @memberof setService
   */
  getObjectType(params) {
    return this.request({
      method: 'get',
      url: `/out/object/getObjectType`,
      params
    });
  }
  /**
   *  外部对象--获取外部对象-字段列表
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  getOutObjFieldList(data) {
    return this.request({
      method: 'post',
      url: `/out/field/list`,
      data
    });
  }
  /**
   *  外部对象--新增字段
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  addOutField(data) {
    return this.request({
      method: 'post',
      url: `/out/field/add`,
      data
    });
  }
  /**
   *  外部对象--字段修改
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  updateOutField(data) {
    return this.request({
      method: 'post',
      url: `/out/field/update`,
      data
    });
  }
  /**
   *  外部对象--字段删除
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  deleteOutField(data) {
    return this.request({
      method: 'post',
      url: `/out/field/delete`,
      data
    });
  }
  /**
   *  外部对象--同步字段
   *
   * @author Zhaolun
   * @param  {Object} params
   * @returns
   * @memberof setService
   */
  syncApproveField(params) {
    return this.request({
      method: 'GET',
      url: `/out/object/auto/update`,
      params
    });
  }
  /********************************
   * 对象权限
   ********************************/
  /**
   *  当前租户对象数据权限列表
   *
   * @author ylq
   * @param  {Object} data
   * @returns
   * @memberof SetService
   */
  permissionList(params) {
    return this.request({
      method: 'GET',
      url: `/sys-entity/data/permission/list`,
      params
    });
  }
  /**
   *  更新当前对象数据权限
   *
   * @author
   * @param  {Object} data
   * @returns
   * @memberof SetService
   */
  permissionUpdate(data) {
    return this.request({
      method: 'post',
      url: `/sys-entity/data/permission/update`,
      data
    });
  }

  /********************************
   * 设置中心--插件--呼叫中心-外呼号码相关api
   ********************************/
  /**
   *  设置中心--插件--呼叫中心-外呼号码--列表
   *
   * @author ylq
   * @param  {Object} data
   * @returns
   * @memberof SetService
   */
  getOutCallList(data) {
    return this.request({
      method: 'post',
      url: `/outmobile/list`,
      data
    });
  }
  /**
   *  设置中心--插件--呼叫中心-外呼号码--添加
   *
   * @author ylq
   * @param  {Object} data
   * @returns
   * @memberof SetService
   */
  addOutCall(data) {
    return this.request({
      method: 'post',
      url: `/outmobile/add`,
      data
    });
  }
  /**
   *  设置中心--插件--呼叫中心-外呼号码--更新修改
   *
   * @author ylq
   * @param  {Object} data
   * @returns
   * @memberof SetService
   */
  updateOutCall(data) {
    return this.request({
      method: 'post',
      url: `/outmobile/update`,
      data
    });
  }
  /**
   *  设置中心--插件--呼叫中心-外呼号码--删除
   *
   * @author ylq
   * @param  {Object} data
   * @returns
   * @memberof SetService
   */
  delOutCall(data) {
    return this.request({
      method: 'post',
      url: `/outmobile/delete`,
      data
    });
  }
  /**
   *  设置中心--插件--呼叫中心-外呼号码--外呼批量绑定
   *
   * @author ylq
   * @param  {Object} data
   * @returns
   * @memberof SetService
   */
  batchAddPheno(data) {
    return this.request({
      method: 'post',
      url: `/sysOutBound/batchAddPheno`,
      data
    });
  }
  /**
   *  设置中心--插件--呼叫中心-外呼号码--外呼批量解绑
   *
   * @author caoJianBo
   * @param  {Object} data
   * @returns
   * @memberof SetService
   */
  batchDelPheno(data) {
    return this.request({
      method: 'post',
      url: `/sysOutBound/batchDelPheno`,
      data
    });
  }
  /**
   *  设置中心--插件--呼叫中心-批量设置默认外呼号码
   *
   * @author ylq
   * @param  {Object} data
   * @returns
   * @memberof SetService
   */
  batchSetDefaultPhone(data) {
    return this.request({
      method: 'post',
      url: `/sysOutBound/batchSetDefaultPhone`,
      data
    });
  }
  /**
   *  设置中心--插件--呼叫中心-外呼号码--设置默认外呼号码
   *
   * @author caoJianBo
   * @param  {Object} data
   * @returns
   * @memberof SetService
   */
  updateDefault(data) {
    return this.request({
      method: 'post',
      url: `/sysOutBound/updateDefault`,
      data
    });
  }
  /**
   *  首页头像--容联设置--获取外呼详情信息
   *
   * @author caoJianBo
   * @param  {Object} data
   * @returns
   * @memberof SetService
   */
  getDetail(data) {
    return this.request({
      method: 'post',
      url: `/sysOutBound/detail`,
      data
    });
  }
  /**
   *  首页头像--火山设置--获取外呼详情信息
   *
   * @author caoJianBo
   * @param  {Object} data
   * @returns
   * @memberof SetService
   */
  getPhoneDetail(data) {
    return this.request({
      method: 'post',
      url: `/outUser/getPhoneDetail`,
      data
    });
  }
  /**
   *  首页头像--火山设置--根据id修改员工手机号
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  updateOutUserConfig(data) {
    return this.request({
      method: 'post',
      url: `/outUser/updateConfig`,
      data
    });
  }
  /********************************
   * 设置中心--流程管理
   ********************************/
  /**
   *  设置中心--流程管理--阶段流程列表
   *
   * @author caoJianBo
   * @param  {Object} data
   * @returns
   * @memberof SetService
   */
  getStageProcessList(data) {
    return this.request({
      method: 'post',
      url: `/stageProcess/list`,
      data
    });
  }
  /**
   *  设置中心--流程管理--启用禁用
   *
   * @author caoJianBo
   * @param  {Object} data
   * @returns
   * @memberof SetService
   */
  enableDisable(data) {
    return this.request({
      method: 'post',
      url: `/stageProcess/enableDisable`,
      data
    });
  }
  /**
   *  设置中心--流程管理--阶段列表查询
   *
   * @author caoJianBo
   * @param  {Object} data
   * @returns
   * @memberof SetService
   */
  getStageList(data) {
    return this.request({
      method: 'post',
      url: `/stageProcess/stageList`,
      data
    });
  }
  /**
   *  阶段流程设置--对象及字段选项值
   *
   * @author CaoJianBo
   * @param  {Object} params
   * @returns
   * @memberof setService
   */
  getObjectAndValues(params) {
    return this.request({
      method: 'get',
      url: `/stageProcess/objectAndValues`,
      params
    });
  }
  /**
   *  阶段流程设置--对象详情接口
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  getObjectDetail(data) {
    return this.request({
      method: 'post',
      url: `/stageProcess/info`,
      data
    });
  }
  /**
   *  阶段流程设置--阶段流程设置第一页新增和编辑
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  addOrUpdate(data) {
    return this.request({
      method: 'post',
      url: `/stageProcess/addOrUpdate`,
      data
    });
  }
  /**
   *  阶段流程设置--进入下一页获取上一页的数据
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  addOrUpdateTask(data) {
    return this.request({
      method: 'post',
      url: `/stageProcess/addOrUpdateTask`,
      data
    });
  }
  /**
   *  阶段流程设置--阶段状态列表查询
   *
   * @author CaoJianBo
   * @param  {Object} params
   * @returns
   * @memberof setService
   */
  getStatusList(params) {
    return this.request({
      method: 'get',
      url: `/stageProcess/statusList`,
      params
    });
  }
  /**
   *  阶段流程设置--进入下一页获取初始数据
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  getTaskInfo(data) {
    return this.request({
      method: 'post',
      url: `/stageProcess/taskInfo`,
      data
    });
  }
  /**
   *  阶段流程设置--商机云文档对象
   *
   * @author CaoJianBo
   * @param  {Object} params
   * @returns
   * @memberof setService
   */
  getCloudObject(params) {
    return this.request({
      method: 'get',
      url: `/stageProcess/cloudObject`,
      params
    });
  }
  /********************************
   * 设置中心--业务插件管理--火山外呼管理
   ********************************/
  /**
   *  外呼管理页--获取外呼池列表
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  getPoolList(data) {
    return this.request({
      method: 'post',
      url: `/pool/list`,
      data
    });
  }
  /**
   *  外呼管理页---添加外呼池
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  addPool(data) {
    return this.request({
      method: 'post',
      url: `/pool/add`,
      data
    });
  }
  /**
   *  外呼池管理--编辑外呼池
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  updatePool(data) {
    return this.request({
      method: 'post',
      url: `/pool/update`,
      data
    });
  }
  /**
   *  外呼池管理---删除外呼池
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  deletePool(data) {
    return this.request({
      method: 'post',
      url: `/pool/delete`,
      data
    });
  }
  /**
   *  外呼管理页--获取外呼号码列表
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  getPhoneList(data) {
    return this.request({
      method: 'post',
      url: `/phone/list`,
      data
    });
  }
  /**
   *  外呼管理页---添加外呼号码
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  addPhone(data) {
    return this.request({
      method: 'post',
      url: `/phone/add`,
      data
    });
  }
  /**
   *  外呼池管理--编辑外呼号码
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  updatePhone(data) {
    return this.request({
      method: 'post',
      url: `/phone/update`,
      data
    });
  }
  /**
   *  外呼池管理---删除外呼号码
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  deletePhone(data) {
    return this.request({
      method: 'post',
      url: `/phone/delete`,
      data
    });
  }
  /**
   *  外呼人员管理页--获取外呼人员管理列表
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  getOutUserList(data) {
    return this.request({
      method: 'post',
      url: `/outUser/list`,
      data
    });
  }
  /**
   *  外呼人员管理页--外呼人员新增
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  addOutUser(data) {
    return this.request({
      method: 'post',
      url: `/outUser/add`,
      data
    });
  }
  /**
   *  外呼人员管理页--外呼人员编辑
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  updateOutUser(data) {
    return this.request({
      method: 'post',
      url: `/outUser/update`,
      data
    });
  }
  /**
   *  外呼人员管理页--外呼人员删除
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  deleteOutUser(data) {
    return this.request({
      method: 'post',
      url: `/outUser/delete`,
      data
    });
  }
  /**
   *  外呼人员管理页--批量操作主叫
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  batchUpdateCalling(data) {
    return this.request({
      method: 'post',
      url: `/outUser/batchUpdateCaller`,
      data
    });
  }
  /**
   *  外呼人员管理页--批量操作被叫
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  batchUpdateCalled(data) {
    return this.request({
      method: 'post',
      url: `/outUser/batchUpdateCallee`,
      data
    });
  }
  /**
   *  外呼人员管理页--所有池子数据
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  getListPoolAll(data) {
    return this.request({
      method: 'post',
      url: `/pool/listForAll`,
      data
    });
  }
  /**
   *  外呼人员管理页--根据池子选项选择不同号码
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  getListPhone(data) {
    return this.request({
      method: 'post',
      url: `/phone/listForAll`,
      data
    });
  }
  /********************************
   * 设置中心--费用中心
   ********************************/
  /**
   *  费用中心--按明细查询详情
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  getChargingList(data) {
    return this.request({
      method: 'post',
      url: `/charging/list`,
      data
    });
  }
  /**
   * *  费用中心--按明细查询详情火山号码月租
   *
   * @author 赵轮
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  getChargingPhoneList(data) {
    return this.request({
      method: 'post',
      url: `/charging/phone/list`,
      data
    });
  }
  /**
   * *  费用中心--按明细查询详情火山号码月租
   *
   * @author 赵轮
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  getAmountList(data) {
    return this.request({
      method: 'post',
      url: `/amount/list`,
      data
    });
  }
  /**
   *  费用中心--火山通话--统计
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  getStatistics(data) {
    return this.request({
      method: 'post',
      url: `/charging/get`,
      data
    });
  }
  /**
   *  费用中心--费用概览--余额概览
   *
   * @author 赵轮
   * @returns
   * @memberof setService
   */
  getBalanceStatistics() {
    return this.request({
      method: 'post',
      url: `/amount/total`
    });
  }
  /**
   *  费用中心--账单明细--火山通话导出
   *
   * @author 赵轮
   * @returns
   * @memberof setService
   */
  chargingExport(data) {
    return this.request({
      method: 'post',
      url: `/charging/down`,
      responseType: 'blob',
      data
    });
  }
  /**
   *  费用中心--账单明细--火山月租导出
   *
   * @author 赵轮
   * @returns
   * @memberof setService
   */
  chargingPhoneExport(data) {
    return this.request({
      method: 'post',
      url: `/charging/phone/down`,
      responseType: 'blob',
      data
    });
  }
  /**
   *  费用中心--账单明细--火山月租导出
   *
   * @author 赵轮
   * @returns
   * @memberof setService
   */
  amountExport(data) {
    return this.request({
      method: 'post',
      url: `/amount/export`,
      responseType: 'blob',
      data
    });
  }
  /***********************
   * 审批管理api
   ***********************/

  /**
   * @description: 审批管理--审批列表
   * @param {*} data
   * @return {*}
   * @author: 赵轮
   */
  getApproveList(data) {
    return this.request({
      method: 'POST',
      url: `/sys-approve/list`,
      data
    });
  }
  /**
   * @description: X布局--tab页签--审批记录
   * @param {*} data
   * @return {*}
   * @author: 赵轮
   */
  getApproveRecord(params) {
    return this.request({
      method: 'GET',
      url: `/sys-approve/history`,
      params
    });
  }
  /**
   * @description: 审批管理--审批列表--修改启用状态
   * @param {*} data
   * @return {*}
   * @author: 赵轮
   */
  updateState(data) {
    return this.request({
      method: 'POST',
      url: `/sys-approve/update/status`,
      data
    });
  }
  /**
   * @description: 审批管理--审批列表--删除审批
   * @param {*} data
   * @return {*}
   * @author: 赵轮
   */
  deleteApprove(params) {
    return this.request({
      method: 'GET',
      url: `/sys-approve/delete`,
      params
    });
  }
  /**
   * @description: 审批管理--审批详情
   * @param {*} data
   * @description: 审批管理--新增审批事件-获取审批触发按钮列表
   * @return {*}
   * @author: 赵轮
   */
  getEventList(params) {
    return this.request({
      method: 'GET',
      url: `/sys-approve/events`,
      params
    });
  }
  /**
   * @description: 审批管理--新增审批事件-获取关联接口映射
   * @return {*}
   * @author: 赵轮
   */
  getMappingRuleList(params) {
    return this.request({
      method: 'GET',
      url: `/sys-approve/mappingRules`,
      params
    });
  }
  /**
   * @description: 审批管理--新增审批事件-获取关联接口映射
   * @param {*} data
   * @return {*}
   * @author: 赵轮
   */
  saveApprove(data) {
    return this.request({
      method: 'POST',
      url: `/sys-approve/save`,
      data
    });
  }
  /**
   * @description: 审批管理--新增审批事件-获取关联接口映射
   * @param {*} data
   * @return {*}
   * @author: 赵轮
   */
  getApprove(params) {
    return this.request({
      method: 'GET',
      url: `/sys-approve/get`,
      params
    });
  }
  /********************************
   * 对象管理--系统对象--导入设置
   ********************************/
  /**
   * @description: 导入模板列表
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */

  getUploadTemplateList(params) {
    return this.request({
      method: 'GET',
      url: `/entity/upload/list/template`,
      params
    });
  }
  /**
   * @description: 导入模板--详情
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */

  getUploadTemplateDetail(params) {
    return this.request({
      method: 'GET',
      url: `/entity/upload/get/template`,
      params
    });
  }
  /**
   * @description: 导入模板--编辑--保存
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */

  updateTemplate(data) {
    return this.request({
      method: 'POST',
      url: `/entity/upload/update/template`,
      data
    });
  }

  /*******************************
   * 对象管理--线索池管理
   *******************************/
  /**
   *  对象管理--线索池管理--根据id获取线索池部门
   *
   * @author 赵轮
   * @returns
   * @memberof setService
   */
  getDepartmentById(params) {
    return this.request({
      method: 'GET',
      url: `/sysDepartment/list/byDepartIds`,
      params
    });
  }
  /**
   *  对象管理--线索池管理--根据id获取线索池部门人员搜索
   *
   * @author 赵轮
   * @returns
   * @memberof setService
   */
  getUserByDeptIdsAndUserIds(params) {
    return this.request({
      method: 'GET',
      url: `/user/selectUserByDepIdsAndUserIds`,
      params
    });
  }
  /**
   *  对象管理--线索池管理--线索池列表
   *
   * @author 赵轮
   * @returns
   * @memberof setService
   */
  getLeadPoolList(data) {
    return this.request({
      method: 'POST',
      url: `/cluePool/listPage`,
      data
    });
  }
  /**
   *  对象管理--线索池管理--获取所有线索池
   *
   * @author 赵轮
   * @returns
   * @memberof setService
   */
  getCluePoolAll() {
    return this.request({
      method: 'GET',
      url: `/cluePool/getAllToMap`
    });
  }
  /**
   *  对象管理--线索池管理--线索池复制
   *
   * @author 赵轮
   * @returns
   * @memberof setService
   */
  getLeadPoolCopy(params) {
    return this.request({
      method: 'GET',
      url: `/cluePool/copy`,
      params
    });
  }
  /**
   *  对象管理--线索池管理--线索池详情
   *
   * @author 赵轮
   * @returns
   * @memberof setService
   */
  getLeadPoolDetail(params) {
    return this.request({
      method: 'GET',
      url: `/cluePool/get`,
      params
    });
  }
  /**
   *  对象管理--线索池管理--线索池是否含有线索
   *
   * @author 赵轮
   * @returns
   * @memberof setService
   */
  isExistLeads(params) {
    return this.request({
      method: 'GET',
      url: `/cluePool/isExist`,
      params
    });
  }
  /**
   *  对象管理--线索池管理--删除线索池
   *
   * @author 赵轮
   * @returns
   * @memberof setService
   */
  leadPoolDelete(params) {
    return this.request({
      method: 'GET',
      url: `/cluePool/delete/`,
      params
    });
  }
  /**
   *  对象管理--线索池管理--新增分配
   *
   * @author 赵轮
   * @returns
   * @memberof setService
   */
  leadPoolRuleAdd(data) {
    return this.request({
      method: 'POST',
      url: `/poolDistribute/addRule`,
      data
    });
  }
  /**
   *  对象管理--线索池管理--编辑分配
   *
   * @author 赵轮
   * @returns
   * @memberof setService
   */
  leadPoolRuleUpdate(data) {
    return this.request({
      method: 'POST',
      url: `/poolDistribute/updateRule`,
      data
    });
  }
  /**
   *  对象管理--线索池管理--删除分配
   *
   * @author 赵轮
   * @returns
   * @memberof setService
   */
  leadPoolRuleDelete(params) {
    return this.request({
      method: 'DELETE',
      url: `/poolDistribute/deleteRule`,
      params
    });
  }
  /**
   *  对象管理--线索池管理--新增回收
   *
   * @author 赵轮
   * @returns
   * @memberof setService
   */
  leadPoolRecycleAdd(data) {
    return this.request({
      method: 'POST',
      url: `/poolRecycle/add`,
      data
    });
  }
  /**
   *  对象管理--线索池管理--编辑回收
   *
   * @author 赵轮
   * @returns
   * @memberof setService
   */
  leadPoolRecycleUpdate(data) {
    return this.request({
      method: 'POST',
      url: `/poolRecycle/update`,
      data
    });
  }
  /**
   *  对象管理--线索池管理--删除回收
   *
   * @author 赵轮
   * @returns
   * @memberof setService
   */
  leadPoolRecycleDelete(params) {
    return this.request({
      method: 'DELETE',
      url: `/poolRecycle/delete`,
      params
    });
  }
  /**
   *  对象管理--线索池管理--新增线索池
   *
   * @author 赵轮
   * @returns
   * @memberof setService
   */
  leadPoolAdd(data) {
    return this.request({
      method: 'POST',
      url: `/cluePool/add`,
      data
    });
  }
  /**
   *  对象管理--线索池管理--新增线索池
   *
   * @author 赵轮
   * @returns
   * @memberof setService
   */
  leadPoolUpdate(data) {
    return this.request({
      method: 'PUT',
      url: `/cluePool/update`,
      data
    });
  }

  /**
   *  对象管理--线索池管理--新增线索池保有量
   *
   * @author 曲世杰
   * @returns
   * @memberof setService
   */

  addCluePoolQuantity(data) {
    return this.request({
      method: 'POST',
      url: `/cluePool/addCluePoolQuantity`,
      data
    });
  }

  /**
   *  对象管理--线索池管理--更新保有量
   *
   * @author 曲世杰
   * @returns
   * @memberof setService
   */
  updateCluePoolQuantity(data) {
    return this.request({
      method: 'POST',
      url: `/cluePool/updateCluePoolQuantity`,
      data
    });
  }

  /**
   *  对象管理--线索池管理--删除保有量
   *
   * @author 曲世杰
   * @returns
   * @memberof setService
   */

  deleteCluePoolQuantity(params) {
    return this.request({
      method: 'DELETE',
      url: `/cluePool/deleteCluePoolQuantity`,
      params
    });
  }

  /**
   *  对象管理--线索池管理--查询保有量
   *
   * @author 曲世杰
   * @returns
   * @memberof setService
   */

  getAllCluePoolQuantity() {
    return this.request({
      method: 'GET',
      url: `/cluePool/getAllCluePoolQuantity`
    });
  }

  /**
   *  对象管理--线索池管理--查询保有量
   * @author 曲世杰
   * @returns
   * @memberof setService
   */
  getCluePoolViewAndLayout() {
    return this.request({
      method: 'GET',
      url: `/cluePool/getCluePoolViewAndLayout`
    });
  }

  /********************************
   * 自动化流程引擎
   ********************************/
  /**
   *  自动化流程列表
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  getFlowList(data) {
    return this.request({
      method: 'post',
      url: `/flow/list`,
      data
    });
  }
  /**
   *  触发动作
   *
   * @author CaoJianBo
   * @param  {Object} params
   * @returns
   * @memberof setService
   */
  getTriggerList(params) {
    return this.request({
      method: 'get',
      url: `/flow/triggerList`,
      params
    });
  }
  /**
   *  获取群组
   *
   * @author LiDongDong
   * @param  {Object} params
   * @returns
   * @memberof setService
   */
  getGroupList(params) {
    return this.request({
      method: 'get',
      url: `/oa/org/chatList`,
      params
    });
  }
  /**
   *  自动化流程---新增流程
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  addFlow(data) {
    return this.request({
      method: 'post',
      url: `/admin/create`,
      data
    });
  }
  /**
   *  自动化流程---AI-关键词
   *
   * @author nn
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  promptList(params) {
    return this.request({
      method: 'get',
      url: `/flow/ai/promptList`,
      params
    });
  }
  /**
   *  自动化流程---AI-模型
   *
   * @author nn
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  modelList(params) {
    return this.request({
      method: 'get',
      url: `/flow/ai/modelList`,
      params
    });
  }
  /**
   *  自动化流程---编辑获取详情
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  getFlowEngineDetail(params) {
    return this.request({
      method: 'get',
      url: `/admin/detail`,
      params
    });
  }
  /**
   *  自动化流程--启用/停用/删除
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  updateFlow(data) {
    return this.request({
      method: 'post',
      url: `/flow/update`,
      data
    });
  }
  /**
   *  自动化流程--获取主对象列表、流程引擎系统对象
   *
   * @author CaoJianBo
   * @param  {Object} params
   * @returns
   * @memberof setService
   */
  getMainObjectList(params) {
    return this.request({
      method: 'get',
      url: `/flow/entites`,
      params
    });
  }

  /**
   *  自动化流程--流程日志列表
   *
   * @author LiDongDong
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  getFlowLogsPage(data) {
    return this.request({
      method: 'post',
      url: `/flow/logsPage`,
      data
    });
  }
  /**
   *  自动化流程--获取搜索条件
   *
   * @author LiDongDong
   * @param  {Object} params
   * @returns
   * @memberof setService
   */
  getFlowLogsKeys(params) {
    return this.request({
      method: 'get',
      url: `/flow/log/keys`,
      params
    });
  }
  /**
   *  自动化流程--日志详情
   *
   * @author LiDongDong
   * @param  {Object} params
   * @returns
   * @memberof setService
   */
  getFlowLogDetail(params) {
    return this.request({
      method: 'get',
      url: `/flow/log/detail`,
      params
    });
  }

  /********************************
   * 合同插件相关API
   ********************************/
  /**
   *  外接数据源列表
   *
   * @author jiuxiuc
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  getSourceList(data) {
    return this.request({
      method: 'post',
      url: `/contractExternalSource/list`,
      data
    });
  }
  /**
   * 刪除数据
   * @param {*} params
   * @returns
   */
  delSourceList(params) {
    return this.request({
      method: 'get',
      url: `/contractExternalSource/delete`,
      params
    });
  }
  /**
   * 外接数据源添加
   * @param {*} data
   * @returns
   */
  addSourceList(data) {
    return this.request({
      method: 'post',
      url: `/contractExternalSource/add`,
      data
    });
  }
  /**
   * 外接数据源修改
   * @param {*} data
   * @returns
   */
  updateSourceList(data) {
    return this.request({
      method: 'post',
      url: `/contractExternalSource/update`,
      data
    });
  }
  /**
   * 外接数据源列表详情
   * @param {*} params
   * @returns
   */
  detailSourceList(params) {
    return this.request({
      method: 'get',
      url: `/contractExternalSource/detail`,
      params
    });
  }
  /************************曹建博 S******************************* */
  /**
   * 合同插件--查询合同模板列表
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  getContractTemplateList(data) {
    return this.request({
      method: 'post',
      url: `/template/list`,
      data
    });
  }
  /**
   * 合同插件--查询映射规则列表
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  getGeneralList(data) {
    return this.request({
      method: 'post',
      url: `/general/list`,
      data
    });
  }
  /**
   * 合同插件--查询映射规则列表
   *
   * @author CaoJianBo
   * @param  {Object} params
   * @returns
   * @memberof setService
   */
  getTemplateRuleList(params) {
    return this.request({
      method: 'get',
      url: `/template/ruleList`,
      params
    });
  }
  /**
   * 合同插件--查询映射规则列表
   *
   * @author CaoJianBo
   * @param  {Object} params
   * @returns
   * @memberof setService
   */
  deleteGeneral(params) {
    return this.request({
      method: 'get',
      url: `/general/delete`,
      params
    });
  }
  /**
   * 合同插件--根据主对象查询子对象查找关联
   *
   * @author CaoJianBo
   * @param  {Object} params
   * @returns
   * @memberof setService
   */
  getSubObject(params) {
    return this.request({
      method: 'get',
      url: `/clue_setting/entity/find`,
      params
    });
  }
  /**
   * 合同插件--查询映射规则详情
   *
   * @author CaoJianBo
   * @param  {Object} params
   * @returns
   * @memberof setService
   */
  getMappingDetail(params) {
    return this.request({
      method: 'get',
      url: `/general/detail`,
      params
    });
  }
  /**
   * 合同插件--新增编辑规则
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  addUpdateGeneral(data) {
    return this.request({
      method: 'post',
      url: `/general/add`,
      data
    });
  }
  /**
   * 合同插件--根据合同id初始化报文
   *
   * @author Jnn
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  initForm(data) {
    return this.request({
      method: 'post',
      url: `/general/initForm`,
      data
    });
  }
  /**
   * 合同插件--查询对象列表
   *
   * @author CaoJianBo
   * @param  {Object} params
   * @returns
   * @memberof setService
   */
  getMainEntityList(params) {
    return this.request({
      method: 'get',
      url: `/sys-entity/entity/list`,
      params
    });
  }
  /**
   * 合同插件--开启同步
   *
   * @author CaoJianBo
   * @param  {Object} params
   * @returns
   * @memberof setService
   */
  getUpdateStatus(params) {
    return this.request({
      method: 'get',
      url: `/general/updateStatus`,
      params
    });
  }
  /************************曹建博 E******************************* */

  /************************秀川 S************************* */
  /**
   * 合同插件--查询接口参数
   *
   * @author jiaxiuc
   * @param  {Object} params
   * @returns
   * @memberof setService
   */
  detailTemplate(params) {
    return this.request({
      method: 'get',
      url: `/template/detail`,
      params
    });
  }
  /**
   * 合同插件--启动配置
   *
   * @author jiaxiuc
   * @param  {Object} params
   * @returns
   * @memberof setService
   */
  updateContractStatus(params) {
    return this.request({
      method: 'get',
      url: `/template/updateStatus`,
      params
    });
  }
  /**
   * 合同插件--查询模板状态
   *
   * @author jiaxiuc
   * @param  {Object} params
   * @returns
   * @memberof setService
   */
  getContractStatus(params) {
    return this.request({
      method: 'get',
      url: `/template/status`,
      params
    });
  }
  /**
   * 合同插件--接口参数更新
   *
   * @author jiaxiuc
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  updateTemplateParam(data) {
    return this.request({
      method: 'post',
      url: `/template/update`,
      data
    });
  }
  /**
   * 获取实体列表
   * @author jiaxiuc
   * @param params 参数对象
   * @returns 返回请求结果
   */
  getEntityList(params) {
    return this.request({
      method: 'get',
      url: `/contractExternalSource/entityList`,
      params
    });
  }

  /************************秀川 E************************* */
  /************************楠楠 S************************* */

  /**
   * 同步规则合同模板字段
   *
   * @author 纪楠楠
   * @param  {Object} params
   * @returns
   * @memberof setService
   */
  contractTemplateField(params) {
    return this.request({
      method: 'get',
      url: `/template/contractTemplateField`,
      params
    });
  }
  /**
   * 同步规则合同模板字段2
   *
   * @author 纪楠楠
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  getInterfaceCondition(data) {
    return this.request({
      method: 'post',
      url: `/general/getInterfaceCondition`,
      data
    });
  }

  /**
   * 配置同步规则新增
   *
   * @author 纪楠楠
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  addSync(data) {
    return this.request({
      method: 'post',
      url: `/general/addSync`,
      data
    });
  }
  /**
   * 配置同步规则修改
   *
   * @author 纪楠楠
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  updateSync(data) {
    return this.request({
      method: 'post',
      url: `/general/updateSync`,
      data
    });
  }

  /**
   * 配置同步规则详情
   *
   * @author 纪楠楠
   * @param  {Object} params
   * @returns
   * @memberof setService
   */
  detailSync(params) {
    return this.request({
      method: 'get',
      url: `/general/detailSync`,
      params
    });
  }
  /**
   * 获取所有对象列表接口
   *
   * @author 纪楠楠
   * @param  {Object} params
   * @returns
   * @memberof setService
   */
  approvedList(params) {
    return this.request({
      method: 'get',
      url: `/approved/branch/list`,
      params
    });
  }
  /**
   * 获取对象切换接口
   *
   * @author 纪楠楠
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  approvedChange(data) {
    return this.request({
      method: 'post',
      url: `/approved/branch/change`,
      data
    });
  }

  contractFieldSyncList(data) {
    return this.request({
      method: 'post',
      url: `/contractFieldSync/list`,
      data
    });
  }
  /**
   * 新增修改同步任务
   *
   * @author 纪楠楠
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  saveOrUpdate(data) {
    return this.request({
      method: 'post',
      url: `/contractFieldSync/saveOrUpdate`,
      data
    });
  }
  /**
   * 删除同步任务
   *
   * @author 纪楠楠
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  contractFieldSyncDelete(data) {
    return this.request({
      method: 'post',
      url: `/contractFieldSync/delete`,
      data
    });
  }
  /**
   * 修改同步任务状态
   *
   * @author 纪楠楠
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  openStatus(data) {
    return this.request({
      method: 'post',
      url: `/contractFieldSync/openStatus`,
      data
    });
  }

  /************************楠楠 E************************* */
  getCrmConnectorList() {
    return this.request({
      method: 'get',
      url: `/connect/list`
    });
  }
  resetConnector() {
    return this.request({
      method: 'get',
      url: `/connect/save`
    });
  }
  /************************审批 S************************* */

  /**
   * 取消审批
   *
   * @author jnn
   * @param  {Object} params
   * @returns
   * @memberof setService
   */
  cancelApproval(params) {
    return this.request({
      method: 'get',
      url: `/sys-approve/cancelApproval`,
      params
    });
  }
  /**
   * 烽火审批流程列表(废弃)
   *
   * @author 纪楠楠
   * @param  {Object} params
   * @returns
   * @memberof setService
   */
  fsApproveList(params) {
    return this.request({
      method: 'get',
      url: `/fsApprove/list`,
      params
    });
  }
  /**
   * 烽火审批流程列表
   *
   * @author 纪楠楠
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  fhlist(data) {
    return this.request({
      method: 'post',
      url: `/approved/configuration/fh/list`,
      data
    });
  }
  /**
   * 飞书审批流程列表
   *
   * @author 纪楠楠
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  fsList(data) {
    return this.request({
      method: 'post',
      url: `/approved/configuration/fs/list`,
      data
    });
  }
  /**
   * 飞书审批流程新增
   *
   * @author 纪楠楠
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  fsAdd(data) {
    return this.request({
      method: 'post',
      url: `/approved/configuration/fs/add`,
      data
    });
  }
  /**
   * 飞书审批流程启用禁用
   *
   * @author 纪楠楠
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  fsEnable(params) {
    return this.request({
      method: 'get',
      url: `/approved/configuration/fs/enable`,
      params
    });
  }
  /**
   * 飞书审批流程详情
   *
   * @author 纪楠楠
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  fsDetail(params) {
    return this.request({
      method: 'get',
      url: `/approved/configuration/fs/detail`,
      params
    });
  }
  /**
   * 飞书审批流程详情
   *
   * @author 纪楠楠
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  fsDelete(params) {
    return this.request({
      method: 'get',
      url: `/approved/configuration/fs/delete`,
      params
    });
  }
  /********************************
   * 流程推进器
   ********************************/
  /**
   * 阶段流程-列表
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  processStagePropellerList(data) {
    return this.request({
      method: 'post',
      url: `/processStagePropeller/list`,
      data
    });
  }
  /**
   * 是否启用
   *
   * @author CaoJianBo
   * @param  {Object} params
   * @returns
   * @memberof setService
   */
  enableStage(params) {
    return this.request({
      method: 'get',
      url: `/processStagePropeller/enable`,
      params
    });
  }
  /**
   * 更新编辑接口（流程图绘制区域及下挂内容部分）
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  saveOrUpdateStage(data) {
    return this.request({
      method: 'post',
      url: `/processStagePropeller/saveOrUpdate`,
      data
    });
  }
  /**
   * 新增、编辑接口（基础信息部分）
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  saveOrUpdateBase(data) {
    return this.request({
      method: 'post',
      url: `/processStagePropeller/saveOrUpdateBase`,
      data
    });
  }
  /**
   * 获取没有配置流程推进器的对象
   *
   * @author CaoJianBo
   * @param  {Object} params
   * @returns
   * @memberof setService
   */
  getStageEntityList(params) {
    return this.request({
      method: 'get',
      url: `/processStagePropeller/getEntityList`,
      params
    });
  }
  /**
   * 详情接口
   *
   * @author CaoJianBo
   * @param  {Object} params
   * @returns
   * @memberof setService
   */
  getStageDetail(params) {
    return this.request({
      method: 'get',
      url: `/processStagePropeller/detail`,
      params
    });
  }
  /**
   * 删除接口
   *
   * @author CaoJianBo
   * @param  {Object} params
   * @returns
   * @memberof setService
   */
  deleteFlowStage(params) {
    return this.request({
      method: 'get',
      url: `/processStagePropeller/del`,
      params
    });
  }
  /************************审批 E************************* */
  /**
   * 子表单编辑
   *
   * @author 张志平
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  subFormUpdate(data) {
    return this.request({
      method: 'post',
      url: `/custom/update`,
      data
    });
  }

  /**
   * 复制租户（内部用）
   *
   * @author sj
   * @param  {Object} params
   * @returns
   * @memberof setService
   */

  CopyTenants(params) {
    return this.request({
      method: 'GET',
      url: `/copy/other/tenant/room`,
      params
    });
  }

  /*******************************
   * 日志管理
   *******************************/
  /**
   *  日志查询
   *
   * @author 袁翔
   * @returns
   * @memberof setService
   */
  getLogList(data) {
    return this.request({
      method: 'POST',
      url: `/opLog/list`,
      data
    });
  }
  /**
   *  日志导出
   *
   * @author 袁翔
   * @returns
   * @memberof setService
   */
  opLogExport(data) {
    return this.request({
      method: 'POST',
      url: `/opLog/export`,
      data
    });
  }
  /**
   *  查看日志详情
   *
   * @author 袁翔
   * @returns
   * @memberof setService
   */
  opLogQueryDetail(id) {
    return this.request({
      method: 'GET',
      url: `/opLog/query/detail/` + id
    });
  }
  /**
   *  跳转查看对象详情
   *
   * @author 袁翔
   * @returns
   * @memberof setService
   */
  opLogQueryJump(id) {
    return this.request({
      method: 'GET',
      url: `/opLog/query/jump/` + id
    });
  }
  /**
   *  操作日志字典码表
   *
   * @author 袁翔
   * @returns
   * @memberof setService
   */
  getLogDict(params) {
    return this.request({
      method: 'GET',
      url: `/opLog/dict`,
      params
    });
  }

  /**
   *  自动化日志列表
   *
   * @author sj
   * @returns
   * @memberof setService
   */

  getAutoProcessLogs(data) {
    return this.request({
      method: 'POST',
      url: `/autoProcess/getAutoProcessLogs`,
      data
    });
  }

  /**
   *  自动化日志详情
   *
   * @author sj
   * @returns
   * @memberof setService
   */
  getAutoProcessLogDetail(data) {
    return this.request({
      method: 'POST',
      url: `/autoProcess/getDetailLogByStepLogId`,
      data
    });
  }
  /**
   * 计算字段错误信息数据
   * @author sj
   *
   */
  getComputedErrorLog(data) {
    const request = {
      method: 'POST',
      url: `/compute/error/log`,
      data
    };
    if (data.apiIndex) {
      request.params = { apiIndex: data?.apiIndex };
    }
    return this.request(request);
  }

  /**
   * 是否发起审批
   * @author sj
   */
  isHitApproval(params) {
    return this.request({
      method: 'GET',
      url: `/sys-approve/hitApproval`,
      params
    });
  }

  /**
   * 是否有复制租户权限
   * @author sj
   * @returns
   */

  hasAllowCopy(params) {
    return this.request({
      method: 'GET',
      url: `/allow/copy`,
      params
    });
  }

  getSubFormDetail(data) {
    return this.request({
      method: 'POST',
      url: `/es/findSubFormBusinessOperationLog`,
      data
    });
  }
  //获取映射模板字段
  getMappingField(params) {
    return this.request({
      method: 'GET',
      url: `/approved/rule/getApproveFieldList`,
      params
    });
  }

  /*************** 点位 start ****************/
  /**
   * @brief 自定义点位菜单列表
   * @author zl
   */
  positionList(params) {
    return this.request({
      method: 'GET',
      url: `/openPosition/list`,
      params
    });
  }
  /**
   * @brief 新增/编辑自定义菜单
   * @author zl
   */
  positionUpdate(data) {
    return this.request({
      method: 'POST',
      url: `/openPosition/addOrUpdate`,
      data
    });
  }
  /**
   * @brief 切换自定义菜单启用状态
   * @author zl
   */
  positionUpdateStatus(data) {
    return this.request({
      method: 'POST',
      url: `/openPosition/updateStatus`,
      data
    });
  }
  /**
   * @brief 切换自定义菜单启用状态
   * @author zl
   */
  positionDelete(params) {
    return this.request({
      method: 'GET',
      url: `/openPosition/deleted`,
      params
    });
  }
  /*************** 点位 end ****************/
  /**
   * 飞书审批同步规则
   * @author sj
   * @returns
   */
  AddApprovedRule(data) {
    return this.request({
      method: 'POST',
      url: `/approved/rule/saveOrUpdate`,
      data
    });
  }

  /**
   * 同步规则列表
   * @author sj
   * @returns
   */

  getApprovedRuleList(data) {
    return this.request({
      method: 'POST',
      url: `/approved/rule/list`,
      data
    });
  }

  /**
   * 同步规则详情
   * @author sj
   * @returns
   */
  getApprovedRuleDetail(params) {
    return this.request({
      method: 'GET',
      url: `/approved/rule/detail`,
      params
    });
  }

  /**
   * 同步规则映射列表
   * @author sj
   * @returns
   */
  getRuleMappingList(data) {
    return this.request({
      method: 'POST',
      url: `/approved/rule/getMappingRuleList`,
      data
    });
  }

  /**
   * 同步规则同步对象列表
   * @author sj
   * @returns
   */
  getApprovedRuleObjectList(params) {
    return this.request({
      method: 'GET',
      url: `/approved/rule/getEntityList`,
      params
    });
  }

  /**
   * 开启/关闭同步规则
   * @author sj
   * @returns
   */
  changeRuleEnable(params) {
    return this.request({
      method: 'GET',
      url: `/approved/rule/enable`,
      params
    });
  }

  /**
   * 删除同步规则
   * @author sj
   * @returns
   */

  deleteApprovedRule(params) {
    return this.request({
      method: 'GET',
      url: `/approved/rule/delete`,
      params
    });
  }

  /**
   * 数据源引用列表
   * @author sj
   * @returns
   */

  getApprovedOutSideList(data) {
    return this.request({
      method: 'POST',
      url: `/approved/outside/list`,
      data
    });
  }

  /**
   * 数据源引用详情
   * @author sj
   * @returns
   */
  getApprovedOutSideDetail(params) {
    return this.request({
      method: 'GET',
      url: `/approved/outside/detail`,
      params
    });
  }

  /**
   * 开启/关闭数据源引用
   * @author sj
   * @returns
   */
  changeOutSideEnable(params) {
    return this.request({
      method: 'GET',
      url: `/approved/outside/enable`,
      params
    });
  }

  /**
   * 删除数据源引用
   * @author sj
   * @returns
   */

  deleteApprovedOutSide(params) {
    return this.request({
      method: 'GET',
      url: `/approved/outside/delete`,
      params
    });
  }

  /**
   * 新增/保存数据源引用
   * @author sj
   * @returns
   */
  saveApprovedOutSide(data) {
    return this.request({
      method: 'POST',
      url: `/approved/outside/saveOrUpdate`,
      data
    });
  }
  /**
   *
   * 获取飞书条件列表
   */

  getFsContentList(data) {
    return this.request({
      method: 'POST',
      url: `/approved/rule/getConditions`,
      data
    });
  }
  // 默认值规则和赋值校验
  checkDefaultRule(data) {
    return this.request({
      method: 'get',
      url: `/default/value/mutualExclusion`,
      params: data
    });
  }
  // 灰度接口
  getGrayScale(data) {
    return this.request({
      method: 'get',
      url: `/user/function/getV2`,
      params: data
    });
  }

  // 详情页布局查询
  getDetailLayout(data) {
    return this.request({
      method: 'get',
      url: `/view/detail/layoutList`,
      params: data
    });
  }

  // 切换详情页布局
  switchDetailLayout(data) {
    return this.request({
      method: 'post',
      url: `/view/update/detail`,
      data
    });
  }

  // 自动化流程获取下拉对象
  getApprovedDropDownList(data) {
    return this.request({
      method: 'POST',
      url: `/flow/query/entites`,
      data
    });
  }
}

export const setService = new SetService();
